module.exports = __webpack_public_path__ + "static/img/twin-wateway-3.1ed1550b.png";